import { Banner } from 'component/Banner/Banner'
import { Button } from 'component/Button'
import { Space } from 'component/Space'
import { Gap } from 'component/Space/Gap'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { TermButton } from 'page/ProfileScreen/DataBanner/TermButton'
import { dataDeleteModal, DataDeleteModalStore } from 'page/ProfileScreen/DataDeleteModal/DataDeleteModalStore'
import { store } from 'store/store'
import { TermType } from 'type/term'

type Props = {
  onCancel?: () => void
}

export const DataBanner = observer((props: Props) => {
  const onCancel = useLatestCallback(async () => {
    if (props.onCancel) props.onCancel()
    else store.profile.step = 'profile'
  })

  const onDelete = useLatestCallback(async () => {
    dataDeleteModal.open(new DataDeleteModalStore())
  })

  return <Banner title={i18n('YourPrivacy')} onCancel={onCancel}>
    <Typo size={14} secondary>
      {i18n('YourDataIsStoredInBrowser')}
    </Typo>
    <Gap height={16} />
    <Vertical gap={16} pad={16} round={16} panel>
      <Typo size={14}>
        {i18n('HowLongShouldDataBeStored')}
      </Typo>
      <Space gap={8} spread>
        <TermButton value={TermType.FOREVER} />
        <TermButton value={TermType.MONTH} />
        <TermButton value={TermType.WEEK} />
      </Space>
      <a href={i18n('PrivacyPolicyUrl')} target="_blank" rel="noopener noreferrer">
        <Space height={40} round={6} style={{ border: '1px dashed var(--ui-text-color)' }} center>
          <Typo size={14} medium upper>
            {i18n('PrivacyPolicy')}
          </Typo>
        </Space>
      </a>
    </Vertical>
    <Gap height={16} />
    <Button large flat error action={onDelete}>
      {i18n('DeleteData')}
    </Button>
  </Banner>
})
